import { useMemo } from "react";
import { useGetFacilitySelectElementsWithSearchQuery } from "../../../middleware/facilitiesApi";

import SelectSimpleInbuilt from "../SelectSimple/Filters/SelectSimpleInbuilt";
import { useAppSelector } from "../../../hooks/redux";
import { getSecurityFilterTable } from "../../../helpers/tableHelper";
import SelectSimpleWithClientSearch from "../SelectSimple/SelectSimpleWithClientSearch";

const allItem = { id: "все", name: "все" };

export const SelectSimpleObject = (props) => {
  const { isTableFilter = true, isAllItem = false } = props;

  const { securityFilterTables } = useAppSelector((state) => state.settings);
  const { data } = useGetFacilitySelectElementsWithSearchQuery({
    name: "",
    equipmentKindGroupId: getSecurityFilterTable(securityFilterTables),
  });

  const options = useMemo(() => {
    if (!data?.length) return [];
    let resData = data;
    if (isAllItem) resData = [allItem, ...resData];
    return resData?.map(({ id, ...item }) => ({ value: id, ...item }));
  }, [data]);

  const Component = isTableFilter
    ? SelectSimpleInbuilt
    : SelectSimpleWithClientSearch;
  return <Component options={options || []} {...props} />;
};
